import { useEffect, useState } from "react";
import { CurrencyExchangeModal } from "./CurrencyExchangeModal";
import Modal from "../../modal/Modal";
import { hasRoles } from "../../../utils/roles";
import PropTypes from "prop-types";
import {
  downloadExcel,
  uploadCurrencyExchangeData,
} from "./CurrencyExchange.functions";
import { DisplayError, FileTray } from "./CurrencyExchange.components";
import "../currency-exchange/CurrencyExchange.css";

import DragDropUploadFile from "../../common/generic-upload-button/DragDropUploadFile";

/// props validation | SQ(javascript:S6774)
CurrencyExchangeUpdate.propTypes = {
  currencies: PropTypes.array,
  user: PropTypes.object,
  currencyExchange: PropTypes.object,
};
export default function CurrencyExchangeUpdate(props) {
  const { currencies, user } = props;
  const { currencyExchange } = props;

  const [modal, setModal] = useState(false);
  const [uploadModal, setUploadModal] = useState(false);
  const [error, setError] = useState({});

  useEffect(() => {
    setError({});
  }, [uploadModal]);

  if (!window.location.href.includes("currency-exchange")) {
    return null;
  }

  if (!hasRoles(user.roles, ["Admin"])) {
    return null;
  }
  async function UploadData(file) {
    await uploadCurrencyExchangeData(
      currencyExchange,
      setError,
      file,
      setUploadModal
    );
  }

  return (
    <div>
      <Modal
        // Modal Props
        title={"Assign Currency Exchange"}
        Component={CurrencyExchangeModal}
        modal={modal}
        setModal={setModal}
        // Component Props
        currencyExchange={currencyExchange}
        currencies={currencies}
      />
      <Modal
        // Modal Props
        title={"Currency Exchange Upload"}
        Component={UploadModal}
        modal={uploadModal}
        setModal={setUploadModal}
        // Component Props
        error={error}
        setError={setError}
        uploadData={UploadData}
      />
      <div className="tender-price-index-article-control-container">
        <button
          title={"Upload Currency Exchange"}
          id={"button-currency-exchange-upload"}
          className="benchmark-control-export-button"
          onClick={() => {
            setUploadModal(true);
          }}
        >
          <i className="fa fa-upload" aria-hidden="true"></i>
        </button>
        <button
          id="currency-exchange-update-button"
          className="benchmark-control-export-button"
          title={"Download Currency Exchange"}
          onClick={() => {
            downloadExcel(
              "CurrencyExchange",
              prepareCurrenciesForDownload(currencies),
              "Currency Exchange"
            );
          }}
        >
          <i className="fa fa-download" aria-hidden="true"></i>
        </button>
      </div>
      <input
        type="button"
        id={"button-location-factor"}
        className="location-factor-set-button"
        value="Update Currency Exchange"
        onClick={() => {
          setModal(true);
        }}
      ></input>
    </div>
  );
}

/// props validation | SQ(javascript:S6774)
UploadModal.propTypes = {
  uploadData: PropTypes.func,
  error: PropTypes.object,
};
export function UploadModal(props) {
  const { uploadData } = props; //function to handle the upload
  const { error, setError } = props; // error state to display errors

  const [file, setFile] = useState([]); // file to upload

  return (
    <div className="location-factors-upload-modal">
      <div className="general-row-container-double">
        <FileTray file={file} />
      </div>
      <FileWithSaveButton
        uploadDataFunction={uploadData}
        error={error}
        setError={setError}
        setFile={setFile}
        data={file[0]}
      />
    </div>
  );
}

/// props validation | SQ(javascript:S6774)
FileWithSaveButton.propTypes = {
  uploadDataFunction: PropTypes.func,
  error: PropTypes.object,
  setError: PropTypes.func,
  setFile: PropTypes.func,
  data: PropTypes.object,
};
export function FileWithSaveButton(props) {
  const { uploadDataFunction, data } = props; //function to handle the upload
  const { error, setError, setFile } = props; // error state to display errors
  const [highlight, setHighlight] = useState(false);

  // To reset File Input
  const [inputKey, setInputKey] = useState(0);

  return (
    <div>
      <div className="general-row-container">
        <DragDropUploadFile
          setFile={setFile}
          allowMultiple={false}
          highlight={highlight}
          setHighlight={setHighlight}
          error={error}
          setError={setError}
          inputKey={inputKey}
          setInputKey={setInputKey}
        />
      </div>
      <div className="general-row-container">
        <DisplayError error={error} />
      </div>
      <div className="general-row-container-double">
        <button
          id={"button-currency-exchange-upload-dialog"}
          className="general-upload-button"
          onClick={async () => {
            await uploadDataFunction(data);
          }}
        >
          Upload
        </button>
      </div>
    </div>
  );
}

function prepareCurrenciesForDownload(data) {
  let Table = [];
  let row = ["Currency Code", "Description", "Exchange Rate"];
  Table.push(row);
  data.forEach((element) => {
    row = [
      element.code,
      element.name + " ( " + element.code + " )",
      element.rate,
    ];
    Table.push(row);
  });
  return Table;
}
